import { Empleado } from '../../empleados';
import { BODEGAS, Ubicaciones } from '../../inventario';
export interface UsuarioSistemaPOST {
  id?: number;

  tipo_identificacion: string; // choice
  identificacion: string;
  razon_social: string; // en ambos

  nombre: string; // calc back
  apellido: string; // calc back

  username: string;
  password: string;
  email: string;
  is_active?: boolean
  
  ///* fk
  empresa: string;
  area: string;
  departamento: string;
  rol: string; // choice

  grupos: number[];
  permisos: number[]; // casos especiales
}

export enum UserRoles {
  GERENCIA = 'GERENCIA',
  ADMINISTRADOR = 'ADMINISTRADOR',
  SUPERVISOR = 'SUPERVISOR',
  AGENTE = 'AGENTE',
}

// // // //  GET Users
export interface UsuariosSistemaGETPagingRes {
  count: number;
  next: string;
  previous: null;
  numero_paginas: number;
  data: UsuariosSistemaGET[];
}

export interface UsuariosSistemaGET {
  id?: number;
  codigo?: string;
  username: string;
  email: string;
  password: string;
  last_login: null;
  is_superuser: boolean;
  first_name: string;
  last_name: string;
  is_staff: boolean;
  is_active: boolean;
  date_joined: Date;
  groups: any[];
  user_permissions: any[];
  full_name?: string;

  permissions: any[];

  profile?: UsuarioSistemaProfile;
  departamento_nombre: string
  empleado?: Empleado;
  create_employee?: boolean;
  canal_venta?: string;

  grupos: number[];
  permisos: number[];
  dias_permitidos?: diasPermitidosInterface[] | [] | null;

  cantidad_consultas?: number | null;
  bodega_data?: BODEGAS[] | null
  ubicacion_data?: Ubicaciones[] | null
  bodega_destino_data?: BODEGAS[] | null
  ubicacion_destino_data?: Ubicaciones[] | null
}

export interface UsuarioSistemaProfile {
  id?: number;

  departamento_nombre: string
  razon_social?: string;
  identificacion?: string;
  tipo_identificacion?: string; // choice
  nombre?: string;
  apellido?: string;

  intentos_fallidos?: number;
  ip_login?: string;
  os_login?: string;

  bio?: string;

  bodegas?:string[]
  ubicaciones?:string[]
  ///* fk
  user?: string;
  rol?: string;
  empresa?: string;
  area?: string;
  departamento?: string;
  canal_venta?: string;

  dias_permitidos?: diasPermitidosInterface[] | [] | null;
  cantidad_consultas?: number | null;
}

interface diasPermitidosInterface {
  dia: number;
  horas: number[];
}

export interface UsuariosSistemaGetExtras extends UsuariosSistemaGET{
  activo?: boolean;
  puedeAprobar?: boolean;
  aprobadorAreaId?:string;
}